import { notificationReducerConstant } from "../reducerConstant";

const initialState = {
  activeNotificationCount: 0,
  notificationData: {},
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case notificationReducerConstant.GET_ACTIVE_COUNT:
      return {
        ...state,
        activeNotificationCount: action.payload.activeNotificationCount,
        notificationData: action.payload.notificationData,
      };

    default:
      return state;
  }
};

export default notificationReducer;
